import { SEVERITY_LABEL, SEVERITY_TONE } from '../../Consts/reconciliation.const';
import {
  ReconciliationActionResponse,
  ReconciliationComponentResponse,
  ReconciliationFindingResponse,
  ReconciliationSubscriptionResponse,
} from '../../Interfaces/api/backoffice/reconciliation.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class ReconciliationFinding {
  organization_id = '';
  organization_name: string | null = null;
  is_owned = false;
  stripe_readable: boolean | null = null;
  subscription: ReconciliationSubscriptionResponse | null = null;
  components: ReconciliationComponentResponse[] = [];
  half_state = 0;
  half_state_licence_ids: string[] = [];
  cancellation_not_applied = 0;
  cancellation_not_applied_licence_ids: string[] = [];
  shapes: string[] = [];
  actions: ReconciliationActionResponse[] = [];
  severity = '';

  constructor(data: Partial<ReconciliationFindingResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.organization_name || this.organization_id;
  }

  get severityLabelKey(): string {
    return SEVERITY_LABEL[this.severity] ?? this.severity;
  }

  get severityTone(): StatusTone {
    return SEVERITY_TONE[this.severity] ?? 'neutral';
  }

  get isInSync(): boolean {
    return this.severity === 'in_sync';
  }

  get actionableActions(): ReconciliationActionResponse[] {
    return this.actions.filter((action) => action.action !== null);
  }

  get unactionableActions(): ReconciliationActionResponse[] {
    return this.actions.filter((action) => action.action === null);
  }
}
